
<!------------------ SHORCUTS --------------------->

<div class=" navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content p-5" style="max-width: 1500px;background-color: #eef0eb;">
  <div   class="col-xg-12 col-lg-12 col-md-12 col-xs-12"  >
    <div class="flex d-flex justify-content-evenly" >
      <div class="col-xg-2 col-lg-3 col-md-3 col-xs-1 col-icon">
        <a target="_blank" href="https://legacy.moebius.tur.ar/eventos">
          <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
            <img loading="lazy" #icon src="{{ routeUploadFile+sectionShortcuts?.info[0].image }}" alt="">
          </span>
          <span>
            <h5 class="title-site text-uppercase" style="max-width: 270px;">{{ sectionShortcuts?.info[0].title }}</h5></span>
        </a>
      </div>
      <div class="col-xg-2 col-lg-3 col-md-3 col-xs-1 col-icon" >
        <a target="_blank" href="https://moebius.tur.ar/pdf/CATALOGO-DIGITAL-MOEBIUS-DMC.pdf">
          <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
            <img loading="lazy" #icon src="{{ routeUploadFile+sectionShortcuts?.info[1].image }}" alt="">
          </span>
          <span>
            <h5 class="title-site text-uppercase" style="max-width: 222px">{{ sectionShortcuts?.info[1].title }}</h5>
          </span>
        </a>
      </div>
      <div class="col-xg-2 col-lg-3 col-md-3 col-xs-1 col-icon">
        <a href="javascript:void(0);" (click)="mannagementRedirect('circuit', 2)">
          <span class="circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
            <img loading="lazy" #icon src="{{ routeUploadFile+sectionShortcuts?.info[2].image }}" alt="">
          </span>
          <span>
            <h5 class="title-site text-uppercase" style="max-width: 210px">{{sectionShortcuts?.info[2].title }}</h5>
          </span>
        </a>
      </div>
      <div class="col-xg-2 col-lg-3 col-md-3 col-xs-1 col-icon">
        <a href="javascript:void(0);" (click)="mannagementRedirect('circuit', 2)">
          <span class=" circle-icon img-fluid mx-auto d-block" [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
            <img loading="lazy" #icon src="{{ routeUploadFile+sectionShortcuts?.info[3].image }}" alt="">
          </span>
          <span>
            <h5 class="title-site text-uppercase" style="max-width: 215px;">{{sectionShortcuts?.info[3].title }}</h5>
          </span>
        </a>
      </div>
    </div>
  </div>
</div>


<!------------------ CARROUSEL --------------------->

<div class=" navbar navbar-expand-xg navbar-expand-lg navbar-expand-md align-items-center top-content p-5">
    <div   class="col-xg-12 col-lg-12 col-md-12 col-xs-12"  style="background-color: #fff">
      <!-- <usb-carousel> (reemplaza ngx-owl-carousel-o): la mecánica (autoplay, flechas,
           breakpoints) la maneja el componente compartido; acá solo se define cómo se ve cada
           slide (#slideTemplate) y se reposicionan las flechas por defecto vía CSS custom
           properties para que queden igual que las de owl (arriba a los costados, -58px/-15px). -->
      <usb-carousel class="shortcuts"
                     [items]="images"
                     [breakpoints]="carouselBreakpoints"
                     [autoplay]="true"
                     [autoplayInterval]="3000"
                     style="--usb-carousel-arrow-top: 55%; --usb-carousel-arrow-height: 100px; --usb-carousel-arrow-size: 40px; --usb-carousel-arrow-offset-left: -15px; --usb-carousel-arrow-offset-right: -58px;">
        <ng-template #slideTemplate let-image>
          <div class="position-relative image-container mx-3">
            <img
                  usbLazyLoadImage
                  loading="lazy"
                  [lazyImage]="image">
            <div class="placeholder position-absolute"
                    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_1}"
                    role="status"
                    style="top: 50%; left: 50%; transform: translate(-50%, -50%);">
            </div>
          </div>
        </ng-template>
      </usb-carousel>
    </div>
</div>



